import React, { useEffect, useState } from "react";
import { TextInput, Menu } from "@mantine/core";
import SearchIcon from "@mui/icons-material/Search";

import currencies from "../../data/currencies";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import colors from "../../configs/colors";
import { sizes } from "../../configs";
type Props = {
  onChoiceDone: (choice: any) => void;
};
const CurrencyMenu = ({ onChoiceDone }: Props) => {
  const [currencyList, setCurrencyList] = useState<any>(currencies);
  const [selCurrency, setSelCurrency] = useState<any | null>(currencies[1]);
  const [curQuery, setCurQuery] = useState<string>("");
  const [isFiltering, setIsFiltering] = useState<boolean>(false);

  const onChoice = (choice: any) => {
    setSelCurrency(choice);
    onChoiceDone(choice);
  };

  const updateCurrency = (val: string) => {
    //  if (curQuery.length >= 2) {
    //  console.log("CURRENCIES : ", currencies);
    //  }
  };
  useEffect(() => {
    setIsFiltering(true);
    setCurQuery(curQuery);
    if (curQuery.length > 0) {
      let curs = currencies.filter(
        (sCur) =>
          sCur.name.toLowerCase().includes(curQuery.toLowerCase()) ||
          sCur.iso.code.toLowerCase().includes(curQuery.toLowerCase()) ||
          curQuery.toLowerCase().includes(sCur.iso.code.toLowerCase())
      );
      setCurrencyList(curs);
      setIsFiltering(false);
    } else {
      setCurrencyList(currencies);
      setIsFiltering(false);
    }
  }, [curQuery]);
  return (
    <div>
      <Menu.Dropdown
        id="currencyDrop"
        sx={{
          padding: "15px 15px",
          borderRadius: sizes.radius,
        }}>
        <TextInput
          variant="filled"
          placeholder="Search a currency"
          size="sm"
          icon={<SearchIcon />}
          style={{
            borderColor: " transparent",
            borderRadius: "50%",
          }}
          mb="sm"
          value={curQuery}
          onChange={(val) => setCurQuery(val.target.value)}
        />
        {!isFiltering ? (
          <div
            style={{
              maxWidth: sizes.dropDownWidth,
              maxHeight: sizes.dropDownHeight,
              overflowY: "auto",
            }}>
            {currencyList.map((cur: any, idx: string) => (
              <Menu.Item
                key={idx}
                component="a"
                href="#"
                onClick={() => onChoice(cur)}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <Typography
                    variant="body1"
                    component="code"
                    style={{
                      flex: 1,
                      fontWeight: "500",
                      fontSize: sizes.dropDownItemSize,
                    }}>
                    {`${cur.iso.code}`}
                  </Typography>
                  <Typography
                    variant="body1"
                    component="code"
                    style={{
                      flex: 3,

                      fontWeight:
                        selCurrency.iso.code === cur.iso.code
                          ? "bolder"
                          : "lighter",
                      fontSize: sizes.dropDownItemSize,
                    }}>
                    {cur.name}
                  </Typography>
                  {selCurrency.iso.code === cur.iso.code && (
                    <CheckCircleIcon
                      sx={{
                        flex: 1,

                        color: colors.main,
                      }}
                    />
                  )}
                </Box>
              </Menu.Item>
            ))}
          </div>
        ) : (
          <Typography variant="body1" component="i">
            {"searching..."}
          </Typography>
        )}
      </Menu.Dropdown>
    </div>
  );
};

export default CurrencyMenu;
